module.exports = __webpack_public_path__ + "static/media/tor.181dcf98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tor.svg
// module id = 293
// module chunks = 0